import { z } from 'zod';
import { allowedPermissionsParser, PrincipalType, principalTypeParser, UNKNOWN_ENUM_VALUE, } from '#validation';
export const WorkspaceMemberPrincipalSchema = z.object({
    type: z.literal(PrincipalType.MEMBER),
    principalId: z.string(),
    publicKey: z.string(),
    ePrivateKeyByInvitationKey: z.string(),
    sMemberByInvitationKey: z.string(),
    allowedPermissions: allowedPermissionsParser,
    invitation: z.object({
        id: z.string(),
        publicKey: z.string(),
        ePrivateKeyByAdminKey: z.string(),
        sInvitationByAdminKey: z.string(),
    }),
});
export const WorkspaceMemberWithoutCryptoPrincipalSchema = z.object({
    type: z.literal(PrincipalType.MEMBER_WITHOUT_CRYPTO),
    principalId: z.string(),
    allowedPermissions: allowedPermissionsParser,
    invitation: z.object({
        id: z.string(),
        publicKey: z.string(),
        ePrivateKeyByAdminKey: z.string(),
        sInvitationByAdminKey: z.string(),
    }),
});
export const WorkspaceGroupPrincipalSchema = z.object({
    type: z.literal(PrincipalType.GROUP),
    principalId: z.string(),
    publicKey: z.string(),
    ePrivateKeyByAdminKey: z.string(),
    sGroupByAdminKey: z.string(),
    allowedPermissions: allowedPermissionsParser,
});
export const WorkspaceGroupWithoutCryptoPrincipalSchema = z.object({
    type: z.literal(PrincipalType.GROUP_WITHOUT_CRYPTO),
    principalId: z.string(),
    allowedPermissions: allowedPermissionsParser,
});
export const UnknownWorkspacePrincipalSchema = z.looseObject({
    type: z.literal(UNKNOWN_ENUM_VALUE),
    principalId: z.string(),
});
const WorkspacePrincipalResponseSchema = z.discriminatedUnion('type', [
    WorkspaceMemberPrincipalSchema,
    WorkspaceMemberWithoutCryptoPrincipalSchema,
    WorkspaceGroupPrincipalSchema,
    WorkspaceGroupWithoutCryptoPrincipalSchema,
    UnknownWorkspacePrincipalSchema,
]);
/**
 * Wraps a principal union so that an unknown `type` coming from a newer WebService
 * is normalized to `$unknown` before the discriminated union is evaluated.
 */
export const WorkspacePrincipalListParser = (principalSchema) => z.array(z.preprocess((input) => {
    const result = z
        .looseObject({ type: principalTypeParser })
        .safeParse(input);
    return result.success ? result.data : input;
}, principalSchema));
export const WorkspacePrincipalListResponseParserSchema = WorkspacePrincipalListParser(WorkspacePrincipalResponseSchema);
